const screenSize = document.getElementById('screen-size');
if (screenSize){
    function getScreenSize(){
        screenSize.innerHTML = ` - ${window.innerWidth }px`;
    }
    window.addEventListener('resize', getScreenSize)

    getScreenSize()
}